import { c as _c } from "react/compiler-runtime";
import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { Icon } from '@/components/Atoms/Icon/Icon';
import type { ReactNode } from 'react';
import styles from './ToolbarIconControl.module.css';
interface IProps {
  label: string;
  icon?: ReactNode;
}
export const ToolbarIconControl = t0 => {
  const $ = _c(9);
  const {
    icon,
    label
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon && <span className={styles.icon}><Icon use={icon} /></span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== label) {
    t2 = <Hidden>{label}</Hidden>;
    t3 = <span className={styles.text} aria-hidden="true">{label}</span>;
    $[2] = label;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <span className={styles.line}>{t1}{t2}{t3}</span>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};